export const KiuAvatar = ({ className = '', active = false }) => (
  <svg viewBox="0 0 64 64" fill="none" aria-hidden="true" className={className}>
    <path d="M13 34v-7a19 19 0 0 1 38 0v7" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
    <rect x="17" y="20" width="30" height="31" rx="12" fill="#1A1D24" stroke="#94A3B8" strokeWidth="1.5" />
    <rect x="8" y="29" width="10" height="17" rx="4" fill="#F59E0B" />
    <rect x="46" y="29" width="10" height="17" rx="4" fill="#F59E0B" />
    <g className="kiu-eyes"><path d="M24 33v4m16-4v4" stroke="#F8FAFC" strokeWidth="3" strokeLinecap="round" /></g>
    <path d="M27 42q5 5 10 0m15 2q0 10-16 10" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" />
    <rect x="30" y="51" width="9" height="5" rx="2.5" fill="#F59E0B" />
    <rect x="25" y="6" width="14" height="6" rx="3" fill={active ? '#34D399' : '#F59E0B'} className="kiu-cue-led" />
  </svg>
);
